import TriangleIcon from 'assets/icons/yellow-warning.svg?react';
import GreenCheckIcon from 'assets/icons/green-check.svg?react';
import ClockIcon from 'assets/icons/clock.svg?react';
import { IdentificationStatusProps } from './types';

export default function getIcon(
  type: IdentificationStatusProps['type'],
  className?: string,
) {
  switch (type) {
    case 'warning':
      return <TriangleIcon className={className} />;
    case 'waiting':
      return <ClockIcon className={className} />;
    case 'success':
      return <GreenCheckIcon className={className} />;
    default:
      return null;
  }
}
